import React from 'react';
import { Helmet } from 'react-helmet-async';

const cleanDescription = str => {
  if (typeof str !== 'string' || !str) {
    return '';
  }

  // STRIP HTML TAGS
  str = str.replace(
    /<([/]?)(p|br|strong|b|em|i|span|a|ul|ol|li|)([^>]*)>/gi,
    ''
  );

  // CLEAN UP HTML CHARACTERS
  str = str.replace(/&nbsp;/gi, ' ');
  str = str.replace(/&amp;/gi, '&');

  // CLEAN UP WHITESPACE
  str = str.replace(/\s+/gi, ' ');

  return str.substring(0, 160);
};

const ProductMeta = ({ product }) => {
  let metaDescription = cleanDescription(
    product?.description?.substring(0, 300)
  );

  if (!metaDescription) {
    metaDescription = cleanDescription(
      product?.shortDescription?.substring(0, 300)
    );
  }
  if (!metaDescription) {
    return false;
  }

  // ONLY ANALYZE ETC IF DESCRIPTION WAS ACTUALLY TOO LONG
  if (metaDescription.length === 160) {
    // FIRST CHECK TO SEE IF WE CAN END NICELY WITH FULL SENTENCES
    const lastDot = metaDescription.lastIndexOf('.');
    const lastExclamation = metaDescription.lastIndexOf('!');
    const lastQuestion = metaDescription.lastIndexOf('?');
    const lastPunct = Math.max(lastDot, lastExclamation, lastQuestion);

    if (lastPunct > 140) {
      metaDescription = metaDescription.substring(0, lastPunct + 1);
    } else {
      // IF NOT, CUT OFF WITH THREE DOTS
      metaDescription = metaDescription.substring(0, 157);
      const lastSpace = metaDescription.lastIndexOf(' ');
      metaDescription = metaDescription.substring(0, lastSpace);
      if (metaDescription.endsWith(',')) {
        metaDescription = metaDescription.substring(
          0,
          metaDescription.length - 1
        );
      }
      metaDescription += '...';
    }
  }

  return (
    <Helmet>
      <meta
        data-rh="true"
        property="og:description"
        content={metaDescription}
      />
      <meta name="description" content={metaDescription} />
    </Helmet>
  );
};

export default ProductMeta;
